import script from "./VContainerPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./VContainerPage.vue?vue&type=script&setup=true&lang=ts"

import "./VContainerPage.vue?vue&type=style&index=0&id=53b1737a&lang=postcss&scoped=true"

import exportComponent from "/builds/frontend/dsp/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53b1737a"]])

export default __exports__